import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";

export default function Slide({ id, name, price, image }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [priceBGN, setPriceBGN] = useState(null);

  useEffect(() => {
    if (!price) return;

    setPriceBGN((Number(price) * 1.95583)?.toFixed(2));
  }, [price]);

  return (
    <div className="slide">
      <div className="image">
        {image ? (
          <img
            src={image}
            alt="Риба на седмицата"
            onClick={() => (window.location.href = `/menu/product/${id}`)}
          />
        ) : (
          <img
            src="https://alexfish-static.s3.eu-north-1.amazonaws.com/missing.svg"
            alt="Not found"
          />
        )}
      </div>
      <div
        className="title"
        onClick={() => (window.location.href = `/menu/product/${id}`)}
      >
        <p>{name}</p>
      </div>
      <div className="price">
        <p>
          {Number(price)?.toFixed(2)} {"€/"}
          {priceBGN !== null ? priceBGN + t("lv") : "Converting..."}
        </p>
      </div>
    </div>
  );
}
